import { Box } from "@mui/system";
import { CustomViewFields, CustomViewUpdateFab } from "../CustomViewModal";
import { useCustomModel } from "components/context/CustomProvider";
import CustomModelProvider from "../CustomModelProvider";
import { Button } from "@mui/material";
import NiceModal from "@ebay/nice-modal-react";

const ModelViewPageFromParent = ({ page, data: parentData }) => {
  const { modelName, idFromParent, itemCreateModal } = page;
  const model = useCustomModel(modelName);

  const id = idFromParent(parentData);

  const handleCreateClick = () => {
    NiceModal.show(itemCreateModal, {
      parent: parentData,
      onDone: () => {
        NiceModal.hide(itemCreateModal);
      },
    });
  };

  return (
    <Box sx={{ maxWidth: "600px", mx: "auto" }}>
      {id && (
        <CustomModelProvider modelName={modelName} id={id}>
          {(data) => {
            return (
              <>
                <CustomViewFields data={data} fields={model.fields} />
                {model.updateModal && (
                  <CustomViewUpdateFab
                    data={data}
                    itemUpdateModal={model.updateModal}
                  />
                )}
              </>
            );
          }}
        </CustomModelProvider>
      )}
      {!id && (
        <Box sx={{ maxWidth: "600px", mx: "auto", textAlign: "center" }}>
          <p>No data available for this view.</p>
          {itemCreateModal && (
            <Button variant="contained" onClick={handleCreateClick}>
              Create
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ModelViewPageFromParent;
